import vue from "vue";
//import "./init";
import * as components from "./components/components";
//import "./fonts/fonts.js";
import { loadComp, loadAsyncComponent } from "./loadComp";
import legacy from "./legacy/legacy";
import utilities from "./utilities/utilities";
import debounce from "lodash/debounce";
import { isNullOrWhitespace } from "./shared/utils/string.ts";
import { getHappy } from "./legacy/happy";
import { getJqm } from "./legacy/jqm";

export default {
    getVue: async function getVue(fnc = undefined) {
        console.warn("Use of deprecated function getVue!");
        if (fnc != null) await fnc(vue);
        return vue;
    },
    Vue: vue,
    components: components,
    stringIsNullOrWhitespace: isNullOrWhitespace,
    loadComp,
    loadAsyncComponent,
    legacy,
    utilities,
    debounce,
    async getCheckoutControls() {
        return (
            await import(
                /* webpackFetchPriority: "high" */
                "./components/controls/checkout/checkout"
            )
        ).default;
    },
    async getProfileControls() {
        return await import(
            /* webpackFetchPriority: "high" */
            "./components/controls/profile"
        );
    },
    async getTracking() {
        const { getTracking } = await import(
            /* webpackFetchPriority: "high" */
            "./tracking"
        );
        return await getTracking();
    },
    getHappy,
    getJqm,
};
